import cloneDeep from "lodash/cloneDeep";


export const convertArrayToObject = (array, key = "id") => {
   if (array === null || array === undefined || !Array.isArray(array))
      return {};

   return array.reduce((current, item) => {
      current[item[key]] = item;
      return current
   }, {})
};

export const addChildrenToItems = (obj, parseKeys = true) => {
   const object = cloneDeep(obj);
   Object.keys(object).forEach(key => {

      if (object[key].parent_id != null && object[object[key].parent_id]) {
         const parent_id = object[key].parent_id;
         //  The material belongs to a category material. It needs to add it as it's child
         if (object[parent_id] !== undefined && !object[parent_id].hasOwnProperty('_children')) {
            object[parent_id]._children = []
         }
         if (object[parent_id] !== undefined) {
            object[parent_id]._children.push(parseKeys ? parseInt(key) : key)
         }
         if (object[parent_id] === undefined) {
            console.warn("Function addChildrenToItems (src/index.js): Object parent not found, parent_id: ", parent_id);
         }
      }
   });
   return object
};

export const cleanCode = code => {
   return replaceAll(code, '\\.', '').trim()
}

export const replaceAll = (text = '', search, replacement) => {
   //for (var x in obj) {
   if (text == null || typeof text !== 'string')
      return '';
   text = text.replace(new RegExp(search, 'g'), replacement);

   return text;
};


/**
 * @param color Hex value format: #ffffff or ffffff
 * @param amt lighten or darken decimal value, example 0.5 to lighten by 50% or 1.5 to darken by 50%.
 */
export const colorShade = (col, amt) => {
   col = col.replace(/^#/, '')
   if (col.length === 3) col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2]
 
   let [r, g, b] = col.match(/.{2}/g);
   ([r, g, b] = [parseInt(r, 16) + amt, parseInt(g, 16) + amt, parseInt(b, 16) + amt])
 
   r = Math.max(Math.min(255, r), 0).toString(16)
   g = Math.max(Math.min(255, g), 0).toString(16)
   b = Math.max(Math.min(255, b), 0).toString(16)
 
   const rr = (r.length < 2 ? '0' : '') + r
   const gg = (g.length < 2 ? '0' : '') + g
   const bb = (b.length < 2 ? '0' : '') + b
 
   return `#${rr}${gg}${bb}`
 }